<template>
<BaseForm
    class="suggestion-form"
    v-model.trim="suggestion"
    @submit="onSubmit"
    :placeholder="placeholder"
    :disabled="disabled || isLoading"
    :isLoading="isLoading"
    :isCoolingDown="isCoolingDown">
    <template #buttonText>
        Post
    </template>
</BaseForm>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import { sleep } from '@shared/utils'
import * as M from '@/store/mutations'
import BaseForm from './BaseForm'

export default {
    name: 'SuggestionForm',
    props: {
        postCooldownMinutes: Number,
        lastSuggestionDate: Date,
        disabled: Boolean,
    },
    data: () => ({
        suggestion: '',
        isLoading: false,
        lastSuggTime: null,
        dateUserCanPost: null,
    }),
    computed: {
        ...mapState(['channel']),
        ...mapGetters(['cooldownTimeRemainingStr']),
        isCoolingDown: vm => vm.disabled,
        placeholder: vm => vm.isCoolingDown
            ? vm.$t('youMayPostAgainIn') + ' ' + vm.cooldownTimeRemainingStr
            : vm.$t('aPostForX', [vm.channel.channelName]),
        isSecretPrefix: vm => {
            const s = vm.suggestion
            return s.startsWith('__channel') ||
                s === '__downtime' || s === '__dev'
        }
    },
    methods: {
        async onSubmit () {
            if (this.isSecretPrefix) {
                return this.handleSecretPrefix()
            }
            try {
                this.isLoading = true

                const payload = {
                    suggestion: this.suggestion
                }
                const [status] = await Promise.all([
                    this.$store.dispatch('postSuggestion', payload),
                    sleep(500) // looks weird if request finishes quickly
                ])
                this.$emit('status', status)

                this.suggestion = '' // clear text to show placeholder
            } finally {
                this.isLoading = false
            }
        },
        // esfandTV: "__channel 38746172" OR "__channel EsfandTV"
        // guanzo: "__channel 23435553" OR "__channel guanzo"
        async handleSecretPrefix () {
            this.$emit('close')

            const text = this.suggestion
            if (text.startsWith('__channel')) {
                const [_, targetChannel] = text.split(' ')
                const channelId = nameToId[targetChannel.toLowerCase()] || targetChannel

                const payload = { channel: { channelId } }
                this.$store.commit(M.UPDATE_CHANNEL, payload)
            } else if (text === '__downtime') {
                this.$store.commit(M.SET_PLANNED_DOWNTIME)
            } else if (text === '__dev') {
                // Must explicitly check process.env.NODE_ENV instead of IS_PROD
                // so uglifyjs can remove this if block during production builds.
                if (process.env.NODE_ENV === 'development') {
                    window.devtools?.connect()
                }
            }
        },
        onClose () {
            this.$emit('close')
        }
    },
    components: {
        BaseForm,
    }
}

const nameToId = {
    esfandtv: '38746172',
    guanzo: '23435553'
}
</script>

<style lang="scss" scoped>

</style>
